import React from 'react'

const Header = () => {

  return (
    <div>
    <h2>
      Expenses Tracker
    </h2>


    </div>
  )
}

export default Header